import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import styled from 'styled-components'

export const StyledConfirmDialog = styled(Dialog)`
  .MuiPaper-root {
    border-radius: 20px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.12);
    overflow: hidden;
    max-width: 430px;
  }
`

export const ConfirmBody = styled(Box)`
  padding: 16px 28px 24px;
`

export const HeaderWrap = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ConfirmTitle = styled(Typography)`
  && {
    font-size: 18px;
    line-height: 52px;
    font-weight: 700;
    color: #111827;
  }
`

export const ConfirmMessage = styled(Typography)`
  && {
    color: #374151;
    font-size: 14px;
    text-align: left;
  }
`

export const OrgName = styled.span`
  color: #111827;
  font-weight: 700;
`

export const ActionsRow = styled(Box)`
  margin-top: 22px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`

export const SecondaryButton = styled(Button)`
  && {
    text-transform: none;
    color: #1f2937;
    font-weight: 600;
    font-size: 14px;
    padding: 8px 4px;
  }
`

export const ConfirmButton = styled(Button)`
  && {
    text-transform: none;
    min-width: 80px;
    background: #dc3545;
    border-radius: 10px;
    font-weight: 700;
    font-size: 12px;
    padding: 5px 10px;
  }

  &&:hover {
    background: #c9303e;
  }
`

export const CloseButton = styled(IconButton)`
  && {
    color: #6b7280;
    margin-top: -2px;
    margin-right: -4px;
  }
`
